import { useCallback, useState } from "react"
import { toast } from "react-toastify"
import { globalAxios } from "../services/globalAxios"
import { AxiosRequestConfig } from "axios"
import { toastError, toastSuccess } from "../components/assets/customToasts"
import { use } from "chai"

type usePostPutType<T> = {
    response: any
    setResponse: React.Dispatch<React.SetStateAction<any>>
    isHandlingUpdateOrCreate: boolean
    handleUpdateOrCreate: (
        method: 'PUT' | 'POST',
        url: string,
        data: T,
        config?: AxiosRequestConfig
    ) => Promise<void>
}

type MaybeAsyncFn = () => void | Promise<void>

type usePostPutParams = {
    onSuccess?: MaybeAsyncFn
    onError?: MaybeAsyncFn
    onSettled?: MaybeAsyncFn
    useToast?: boolean //used to disable toast notifications when message errors are handled elsewhere (poppups, modals, etc)
}

export default function usePostPut<T>({ onSuccess, onError, onSettled, useToast }: usePostPutParams): usePostPutType<T> {

    const [isHandlingUpdateOrCreate, setIsHandlingUpdateOrCreate] = useState(false)
    const [response, setResponse] = useState<any>(null)

    const handleUpdateOrCreate = useCallback(async (
        method: 'POST' | 'PUT',
        url: string,
        data: T,
        config: AxiosRequestConfig = {}
    ) => {
        console.log('handleUpdateOrCreate called with:', data)
        setIsHandlingUpdateOrCreate(true)

        let _toast: any = null

        if (useToast !== false) {
            _toast = toast('Saving data...', { toastId: method === 'POST' ? 'toast-post' : 'toast-put', isLoading: true })
        }

        try {
            // to save result
            let response;

            method === 'POST' ? response = await globalAxios.post(url, data, config) : response = await globalAxios.put(url, data, config)

            console.log('Response: ', response.data)

            setResponse(response.data)

            useToast !== false && toastSuccess(_toast, method === 'POST' ? 'Successfully created.' : 'Successfully updated.')

            await onSettled?.()
            await onSuccess?.()
        } catch (error) {
            console.log('Hook UsePostPut', error)
            useToast !== false && toastError(_toast, (error as any)?.response?.data?.message || 'Unexpected error.')
            await onError?.()
        } finally {
            setIsHandlingUpdateOrCreate(false)
        }

    }, [onSuccess, onError, onSettled])

    return {
        handleUpdateOrCreate,
        isHandlingUpdateOrCreate,
        setResponse,
        response
    }
}